import React, {useState} from 'react';
import {Box, CircularProgress, Alert, Button, Typography} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import {useGetCampaignsQuery} from 'store/slices/campaignSlice';
import {ISortConfig} from 'hooks/useSortColumn';

import styles from './CampaignsPage.module.scss';
import {createButton} from 'styles/MUIStyles/buttons';

import CampaignsTable from './CampaignsTable';
import CreateCampaignModal from './CampaignsTable/modals/CreateCampaignModal';
import {CampaignsToolbar} from './CampaignsToolbar/CampaignsToolbar';
import {useAppSelector} from 'store/store';
import {EmptyState} from 'components/TableEmptyState/TableEmptyState';
import {getFirstServerErrorMessage} from 'core/utils';

// -------- SORT HOOK ----------
const useSortColumn = (defaultColumn: string) => {
  const [config, setConfig] = useState<ISortConfig>({
    column: defaultColumn,
    direction: 'asc',
  });

  const handleColumnClick = (column: string) => {
    let direction: ISortConfig['direction'] = 'asc';

    if (config.column === column && config.direction === 'asc')
      direction = 'desc';
    else if (config.column === column && config.direction === 'desc')
      direction = null;

    setConfig({column, direction});
  };

  return {sortConfig: config, handleColumnClick};
};

// -------- PAGE COMPONENT ----------
export const CampaignsPage = () => {
  const {sortConfig, handleColumnClick} = useSortColumn('name');

  const [createOpen, setCreateOpen] = useState(false);
  const [isActive, setIsActive] = useState(true); // единственный фильтр

  // -------- API REQUEST ----------
  const {
    data: campaignsData,
    isError,
    isLoading,
    error,
  } = useGetCampaignsQuery({isActive});

  const campaigns = campaignsData || [];

  const role = useAppSelector((state) => state.auth.role);

  const isAdmin = role === 'Admin' || role === 'SuperAdmin';
  return (
    <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
      {/* -------- HEADER -------- */}
      <div className={styles.campaignsTop}>
        <h1 className={styles.campaignsTitle}>Campaigns</h1>
        {isAdmin && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setCreateOpen(true)}
            sx={createButton}
          >
            Add Campaign
          </Button>
        )}
      </div>
      {/* -------- TOOLBAR (ТОЛЬКО isActive) -------- */}

      {/* -------- TABLE -------- */}
      <div className={styles.campaignsMainContent}>
        {isAdmin && (
          <CampaignsToolbar isActive={isActive} setIsActive={setIsActive} />
        )}

        {isLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height={400}
          >
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Alert severity="error">{getFirstServerErrorMessage((error as any)?.data)}</Alert>
        ) : !campaigns.length ? (
          <EmptyState
            title="No campaigns yet"
            hint="Create the first campaign to see it here"
          />
        ) : (
          <CampaignsTable
            campaigns={campaigns}
            metaData={null} // больше не используется
            sortConfig={sortConfig}
            handleColumnClick={handleColumnClick}
          />
        )}
      </div>

      {/* -------- CREATE MODAL -------- */}
      <CreateCampaignModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
      />
    </div>
  );
};
